import { ShippingContextDataFn } from "../../instantAnswerDataFunctions/shippingContextDataFn";
import { ShouldDisplayMessageCTADataFn } from "../../instantAnswerDataFunctions/shouldDisplayMessageCTADataFn";
import { GoToOrderFulfillmentCTA, GoToOrdersCTA } from "./ctas";
export var ShipFromAddressIA = function ShipFromAddressIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    },
    additionalRequiredData: [ShippingContextDataFn, ShouldDisplayMessageCTADataFn]
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return SHIP_FROM_ADDRESS_TITLE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [SHIP_FROM_ADDRESS_DESCRIPTION_LIST1(strictLocalize), SHIP_FROM_ADDRESS_DESCRIPTION_LIST2(strictLocalize), SHIP_FROM_ADDRESS_DESCRIPTION_LIST3(strictLocalize), SHIP_FROM_ADDRESS_DESCRIPTION_LIST4(strictLocalize)];
    }
  };
};
var SHIP_FROM_ADDRESS_TITLE = function SHIP_FROM_ADDRESS_TITLE(strictLocalize) {
  return strictLocalize({
    id: "Uo4MYX",
    defaultMessage: [{
      "type": 0,
      "value": "How to update your ship from address"
    }]
  });
};
var SHIP_FROM_ADDRESS_DESCRIPTION_LIST1 = function SHIP_FROM_ADDRESS_DESCRIPTION_LIST1(strictLocalize) {
  return strictLocalize({
    id: "SAG6w0",
    defaultMessage: [{
      "type": 0,
      "value": "1. Go to your Orders."
    }]
  });
};
var SHIP_FROM_ADDRESS_DESCRIPTION_LIST2 = function SHIP_FROM_ADDRESS_DESCRIPTION_LIST2(strictLocalize) {
  return strictLocalize({
    id: "LHQiF0",
    defaultMessage: [{
      "type": 0,
      "value": "2. Click on any order."
    }]
  });
};
var SHIP_FROM_ADDRESS_DESCRIPTION_LIST3 = function SHIP_FROM_ADDRESS_DESCRIPTION_LIST3(strictLocalize) {
  return strictLocalize({
    id: "vVMYwJ",
    defaultMessage: [{
      "type": 0,
      "value": "3. Edit the ship-from address."
    }]
  });
};
var SHIP_FROM_ADDRESS_DESCRIPTION_LIST4 = function SHIP_FROM_ADDRESS_DESCRIPTION_LIST4(strictLocalize) {
  return strictLocalize({
    id: "9/PmwC",
    defaultMessage: [{
      "type": 0,
      "value": "4. Save any changes you make."
    }]
  });
};
var getPrimaryCTA = function getPrimaryCTA(context, strictLocalize) {
  var _context$brandOrder, _context$brandOrder$b;
  var brandOrderToken = (_context$brandOrder = context.brandOrder) === null || _context$brandOrder === void 0 ? void 0 : (_context$brandOrder$b = _context$brandOrder.brand_order) === null || _context$brandOrder$b === void 0 ? void 0 : _context$brandOrder$b.token;
  if (!brandOrderToken) {
    return GoToOrdersCTA(strictLocalize);
  }
  return GoToOrderFulfillmentCTA(brandOrderToken, strictLocalize);
};